import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { push } from 'connected-react-router'

import SignInForm from '../components/SignInForm';
import { login } from '../redux/modules/user/action';

class SignIn extends React.Component {
  state = {
    loading: false
  };

  onLogin = (props) => {
    const { loading } = this.state;
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch(login(props))
      .then((user) => user && dispatch(push('/dashboard')));
  }

  render () {
    const { handleSubmit, submitting, error } = this.props;
    const { loading } = this.state;
    return (
      <React.Fragment>
        <SignInForm 
          onLogin={this.onLogin}
          handleSubmit={handleSubmit}
          submitting={submitting}
          error={error}
        />
      </React.Fragment>
    )
  }
}

const connectReduxForm = reduxForm({
  form: "Login",
  enableReinitialize: true
});

function mapStateToProps(state){
  return {
      error: state.user.error,
  }
}

SignIn = connect(
  mapStateToProps
)(SignIn);

export default connectReduxForm(SignIn);